import { render, staticRenderFns } from "./changelist.vue?vue&type=template&id=2f3b2e1c&"
import script from "./changelist.vue?vue&type=script&lang=js&"
export * from "./changelist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("c:\\Users\\860552\\Downloads\\work\\kronex-home.by\\bitrix\\templates\\b2bportal_kr\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('2f3b2e1c', component.options)
    } else {
      api.reload('2f3b2e1c', component.options)
    }
    module.hot.accept("./changelist.vue?vue&type=template&id=2f3b2e1c&", function () {
      api.rerender('2f3b2e1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/scripts/vue/components/sectionsextra/changelist.vue"
export default component.exports